import "react-day-picker/style.css";

import { DayPicker } from "react-day-picker";

import { useMeetingDetails } from "../../hooks/useMeetingDetails";

const css = `
.rdp-nav {
  width: 100%;
  justify-content: space-between;
}

.rdp-month_caption {
  justify-content: center;
}
.rdp-month_caption .rdp-caption_label {
  color: white;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}

.rdp-weekdays {
  color: white;
}

.my-today {
  color: gray;
  position: relative;
}

.my-today::after {
  content: "";
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  background: gray;
  border-radius: 50%;
}

.my-selected {
  background: #08253D;
  color: #01C2F3;
  border-radius: 100%;
}

.my-month {
  color: rgba(255, 255, 255, 0.61);
}

.rdp-weeks {
  color: rgba(255, 255, 255, 0.61);
}

.rdp-button_previous,
.rdp-button_next {
  height: 38px;
  width: 38px;
  border-radius: 100%;
}
.rdp-button_previous:hover,
.rdp-button_next:hover {
  background: #08253D;
}
.rdp-button_previous[aria-disabled="true"] {
  background: transparent;
}
.rdp-button_previous[aria-disabled="true"] .rdp-chevron {
  fill: gray;
}
.rdp-chevron {
  height: 17px;
  width: 17px;
  fill: #01C2F3;
}
.rdp-day:not([data-disabled]):hover {
  background: #08253D;
  border-radius: 100%;
}
`;

export const DatePicker = () => {
  const { userTimezone, date, setDate } = useMeetingDetails();

  return (
    <div className="flex items-center justify-center">
      <style>{css}</style>
      <DayPicker
        animate
        mode="single"
        selected={date}
        onSelect={setDate}
        timeZone={(userTimezone as any).value}
        // numberOfMonths={240}
        startMonth={new Date()}
        disabled={{ before: new Date() }}
        weekStartsOn={1}
        formatters={{
          formatWeekdayName: (date) =>
            date
              .toLocaleDateString("en-US", { weekday: "short" })
              .toUpperCase(),
        }}
        modifiersClassNames={{
          today: "my-today",
          selected: "my-selected",
          monthCaption: "rdp-caption_label",
          weekdays: "rdp-weekdays",
          weekRows: "rdp-weeks",
          day: "rdp-day",
        }}
      />
    </div>
  );
};
